export const demoScreenCommunicationRoute = {
  path: '/demo-communication-screen',
  component: 'demo-communication-screen',
  componentName: 'Communication Demo Screens',
  theme: 'instaCred',
  template: 'demoScreens',
};

export const demoScreenCommunicationRoutes = [demoScreenCommunicationRoute];



// WEBPACK FOOTER //
// ./alias/demoScreenRoutes.js